import React, { useEffect } from "react";
import "../styles/LaunchBanner.css";

const LaunchBanner = ({ goToSignup }) => {
  useEffect(() => {
    document.body.classList.add("banner-visible");
    return () => document.body.classList.remove("banner-visible");
  }, []);
  
  const handleClick = (e) => {
    if (goToSignup) {
      e.preventDefault();
      goToSignup(e);
    }
  };

  return (
    <div className="launch-banner">
      🚀 BestDay2Marry is live!{" "}
      <a href="/signup" onClick={handleClick}>
        Get started →
      </a>
    </div>
  );
};

export default LaunchBanner;
